module.exports = __webpack_public_path__ + "static/GilroyAlt-Medium-67fb92c9e429cda4095cfc2771721aa2.woff";